/* eslint-disable */
import { LOCATION_CHANGE } from 'connected-react-router';
import { matchPath } from 'react-router-dom';
import { DASHBOARD_PAGE_PATH } from '../../../../Pages/Dashboard/Dashboard.page.route';
import { ERROR_PAGE_PATH } from '../../../../Pages/Error/Error.page.route';
import { HELP_PAGE_PATH } from '../../../../Pages/Help/Help.page.route';
import { HOME_PAGE_PATH } from '../../../../Pages/Home/Home.page.route';
import { LOGIN_PAGE_PATH } from '../../../../Pages/Login/Login.page.route';
import { LOGOUT_PAGE_PATH } from '../../../../Pages/Logout/Logout.page.route';
import { ORDER_PAGE_PATH } from '../../../../Pages/Order/Order.page.route';
import { ORDER_CONCRETE_DELIVERIES_PAGE_PATH } from '../../../../Pages/OrderConcreteDeliveries/OrderConcreteDeliveries.page.route';
import { ORDERS_PAGE_PATH } from '../../../../Pages/Orders/Orders.page.route';
import { PROFILE_PAGE_PATH } from '../../../../Pages/Profile/Profile.page.route';
import { SETTINGS_PAGE_PATH } from '../../../../Pages/Settings/Settings.page.route';
import { TERMS_CONDITIONS_PAGE_PATH } from '../../../../Pages/Terms/Terms.page.route';

const routes = [
  DASHBOARD_PAGE_PATH,
  ERROR_PAGE_PATH,
  HELP_PAGE_PATH,
  HOME_PAGE_PATH,
  LOGIN_PAGE_PATH,
  LOGOUT_PAGE_PATH,
  ORDER_CONCRETE_DELIVERIES_PAGE_PATH,
  ORDER_PAGE_PATH,
  ORDERS_PAGE_PATH,
  PROFILE_PAGE_PATH,
  SETTINGS_PAGE_PATH,
  TERMS_CONDITIONS_PAGE_PATH,
];

/**
 * Get path pattern
 * @param {string} pathname The actual pathname
 * @returns {string} The matched pattern
 */
const getPathPattern = (pathname) => {
  return routes.reduce((acc, path) => {
    if (acc === null) {
      const match = matchPath(pathname, {
        exact: true,
        path,
      });
      if (match) {
        return match;
      }
    }
    return acc;
  }, null);
};

/**
 * The router events
 * @returns {any} The analytics data
 */
const routerEvents = () => ({
  [LOCATION_CHANGE]: ({ payload }) => {
    const {
      location: { pathname },
    } = payload;
    return {
      event: `Page View`,
      page: getPathPattern(pathname),
    };
  },
});

export default routerEvents;
